import React, { useEffect } from 'react';
import { string, func } from 'prop-types';
import { Alert } from '@one-thd/sui-atomic-components';

export const BuyboxMessage = React.forwardRef(({ message, status, onRender }, ref) => {
  useEffect(() => {
    onRender();
  }, []);

  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    <div className="sui-flex sui-flex-col sui-max-w-[420px]" ref={ref}>
      <Alert status={status}>
        {message}
      </Alert>
    </div>
  );
});

BuyboxMessage.propTypes = {
  message: string.isRequired,
  status: string,
  onRender: func
};

BuyboxMessage.defaultProps = {
  status: 'warning',
  onRender: () => {}
};